export default __webpack_public_path__ + "assets/images/00003d13c55cab171157c1ee253f5850.svg";